
































































import Vue from 'vue'
import PilotArmorCard from './_PLArmorCard.vue'
import PilotWeaponCard from './_PLWeaponCard.vue'
import PilotGearCard from './_PLGearCard.vue'
import { Bonus } from '@/classes/components/feature/bonus/Bonus'
import { PilotArmor, PilotWeapon, PilotGear } from '@/class'

export default Vue.extend({
  name: 'cc-pilot-loadout',
  components: { PilotArmorCard, PilotWeaponCard, PilotGearCard },
  props: {
    pilot: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
    },
  },
  computed: {
    gear() {
      return this.pilot.Loadout.Gear
    },
    extendedGear() {
      const extraGearSlots = Bonus.Int(0, 'pilot_gear_slots', this.pilot)
      if (extraGearSlots > 0) return this.pilot.Loadout.redoExtendedGear(extraGearSlots)
      return []
    },
    weapons() {
      return this.pilot.Loadout.Weapons
    },
    extendedWeapons() {
      const extraWeaponSlots = Bonus.Int(0, 'pilot_weapon_slots', this.pilot)
      if (extraWeaponSlots > 0) return this.pilot.Loadout.redoExtendedWeapons(extraWeaponSlots)
      return []
    },
  },
  methods: {
    exotics(type: string) {
      return this.pilot.SpecialEquipment.filter(x => x.ItemType === type)
    },
    setArmor(a: PilotArmor | null) {
      this.$set(this.pilot.Loadout.Armor, 0, a)
      this.pilot.Heal()
    },
    setWeapon(w: PilotWeapon | null, idx: number, extended: boolean) {
      const weaponArray = extended ? this.pilot.Loadout.ExtendedWeapons : this.pilot.Loadout.Weapons
      this.$set(weaponArray, idx, w)
      this.pilot.Heal()
    },
    setGear(g: PilotGear | null, idx: number, extended: boolean) {
      const gearArray = extended ? this.pilot.Loadout.ExtendedGear : this.pilot.Loadout.Gear
      this.$set(gearArray, idx, g)
      this.pilot.Heal()
    },
  },
})
